import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timestamp',
  standalone: true
})
export class TimestampPipe implements PipeTransform {

  transform(value: any, format: string = 'short'): string {
    if (!value) {
      return '—';
    }

    // Handle different timestamp formats
    let timestamp: number;
    
    if (typeof value === 'string') {
      // If it's a string, try to parse it as a number
      timestamp = parseInt(value, 10);
    } else if (typeof value === 'number') {
      timestamp = value;
    } else {
      return '—';
    }

    // Check if timestamp is in seconds (Unix timestamp) or milliseconds
    // Unix timestamps are typically 10 digits (seconds since epoch)
    // JavaScript Date expects milliseconds, so if it's 10 digits, multiply by 1000
    if (timestamp.toString().length === 10) {
      timestamp = timestamp * 1000;
    }

    // Create date and format it
    const date = new Date(timestamp);
    
    // Check if date is valid
    if (isNaN(date.getTime())) {
      return '—';
    }

    // Format the date based on the format parameter
    switch (format) {
      case 'short':
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
      case 'long':
        return date.toLocaleString();
      case 'date':
        return date.toLocaleDateString();
      case 'time':
        return date.toLocaleTimeString();
      default:
        return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
    }
  }
}
